import { Skeleton } from '@xefi/x-react/skeleton';

export const IntroductionPageSkeleton = () => {
   return (
      <div className='flex min-h-[75vh] px-10 py-4'>
         <div className='flex w-full flex-col gap-4 overflow-y-auto'>
            <Skeleton className='h-4 w-32' />
            <div className='border-border relative mt-1 flex w-full justify-center rounded-md border py-4'>
               <Skeleton className='h-[280px] w-[474px] rounded-lg' />
            </div>
            <div className='flex flex-col gap-2'>
               <Skeleton className='mb-2 h-4 w-48' />
               <div className='border-border rounded-lg border p-2'>
                  <Skeleton className='my-2 h-2 w-48' />
                  <div className='from-custom-blue/10 via-custom-blue/50 to-custom-blue/10 mb-2 flex h-px bg-linear-to-r' />
                  <div className='flex w-full justify-between'>
                     <div className='flex-1'>
                        <Skeleton className='h-20 w-full' />
                     </div>
                  </div>
               </div>
            </div>
            <div className='mt-6 h-auto'>
               <Skeleton className='h-6 w-24 rounded-t-md' />
               <div className='border-border relative flex cursor-pointer justify-center gap-4 rounded-sm border py-4'>
                  <Skeleton className='h-[280px] w-[474px] rounded-lg' />
               </div>
            </div>
            <div className='flex justify-end gap-2 py-4'>
               <Skeleton className='h-8 w-24' />
            </div>
         </div>
      </div>
   );
};
